import { render } from "./SimulationView.vue?vue&type=template&id=22f0ef99&ts=true"
import script from "./SimulationView.vue?vue&type=script&lang=ts"
export * from "./SimulationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__